import { render } from "./RemoveQuestionFromQuizModal.vue?vue&type=template&id=be21e704&scoped=true&ts=true"
import script from "./RemoveQuestionFromQuizModal.vue?vue&type=script&lang=ts"
export * from "./RemoveQuestionFromQuizModal.vue?vue&type=script&lang=ts"

import "./RemoveQuestionFromQuizModal.vue?vue&type=style&index=0&id=be21e704&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be21e704"]])

export default __exports__